import React from 'react';
import {Col, Container, Row} from 'react-bootstrap'
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';

const Answers = ({questions, noOfQuestions, qSetNum, userAnswers, testnumber}) => {
    // console.log(questions)
    // console.log(noOfQuestions)
    // console.log(qSetNum)
    // console.log(userAnswers)
    // console.log(testnumber)
    let answers = []
    for(let i=0; i<noOfQuestions; i++){
        answers.push(
        <div className="response">
            {userAnswers ? 
             //<div className="wrong-response">a</div>
             (questions[testnumber][i].answer === userAnswers['q'+(i+1)]) ? <p className="correct-response">a</p> : <p className="wrong-response">b</p>
             : '-'}
        </div>)
    }
    return answers
}

const DisplayTestDetails = ({questionSets, testData, questions}) => {
    console.log(questions)
    const testno = (testData.testnumber) ? Number(testData.testnumber) : null;
    const noOfQuestions = (questions && testData.testnumber !== 'undefined') ? Object.keys(questions[testno]).length : null
    //console.log(noOfQuestions)
    
    return (
        <>
        {(testData.testnumber && testData.testnumber !== 'undefined') ?
            <Col>
                <h4 className="text-color">{questionSets && questionSets[testno-1].qSetName}</h4>
                <Container className="userAnswers">
                    <h6>Options Choosed:</h6>
                    {/* {testData.testnumber !== 'undefined' ? <div className="response">{1}</div> : null  
                    } */}
                    <Answers noOfQuestions={noOfQuestions} questions={questions} qSetNum={testno} userAnswers={testData.testData.userAnswers} testnumber={testData.testnumber}/>
                </Container>
            </Col>
            : null
        }
        </>
    );
}

const mapStateToProps = (state) => {
    const questionSets = state.firebase.data.questionSets;
    const questions = state.firebase.data.questions;
    return {
        questionSets: questionSets,
        questions: questions
    }
}

export default compose(
    connect(mapStateToProps),
    firebaseConnect([
        'questionSets',
        'questions'
    ])
)(DisplayTestDetails);
